module.exports = __webpack_public_path__ + "static/media/cancel.6685cc2d.svg";